import { render } from "./CreatorIncomeView.vue?vue&type=template&id=d97ae740&scoped=true"
import script from "./CreatorIncomeView.vue?vue&type=script&lang=js"
export * from "./CreatorIncomeView.vue?vue&type=script&lang=js"

import "./CreatorIncomeView.vue?vue&type=style&index=0&id=d97ae740&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d97ae740"]])

export default __exports__